import React from 'react';
import { FormControl, InputLabel, OutlinedInput, FormHelperText, TextField, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import { generateTestId } from 'app/functions';

export const HotTextInput = ({
  name,
  control,
  label,
  required = false,
  helperText,
  rules = {},
  testID,
  ...rest
}) => {
  // If required is true, add it to the rules
  if (required && !rules.required) {
    rules.required = 'This field is required';
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <FormControl fullWidth error={!!error}>
          {label && (
            <InputLabel
              sx={{
                position: 'relative',
                transform: 'none',
                color: "text.inputLabel",
              }}
            >
              <Typography variant="inputLabel">
                  {label}
              </Typography>
            </InputLabel>
          )}

          <TextField
            {...field}
            {...rest}
            label={null}
            error={!!error}
            testID={generateTestId(testID, `${name}-input`)}
            helperText={error ? error.message : helperText}
            sx={{
              '& .MuiFormHelperText-root': {
                marginTop: "5px",
                minHeight: "1rem",
                position: "absolute",
                bottom: -20,
                visibility: (error || helperText) ? 'visible' : 'hidden'
              }
            }}
          />
          
        </FormControl>
      )}
    />
  );
};

export default HotTextInput; 